import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import "../css/main.css";
import UnderConstruction from "../images/under-construction.png";

const Construction = () => {
  return (
    <div>
      <Header />
      <div className="error404">
        <div class="container">
          <div className="background-img">
            <img src={UnderConstruction} alt="under construction" />
          </div>
          <div className="info-box">
            <h2>Lucrăm la ceva nou pentru tine!</h2>
            <p>
              Această pagină este în curs de dezvoltare pentru a-ți oferi o
              experiență mai bună. Te rugăm să revii în curând!
            </p>
            <div className="redirect-button">
              <a className="button primary" href="/">
                Înapoi acasă
              </a>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Construction;
